import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Stack } from '@mui/material';
import '../../../styles/DocumentDetails.css';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { useGetInvoiceHandler } from '../dataHandlers/getInvoiceHandler';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';
import InvoiceForm from '../components/InvoiceForm';
import { useResubmitInvoiceHandler } from '../dataHandlers/resubmitInvoiceHanlder';
import { usePermissions } from '../../../hooks/usePermissions';
import { UPDATE_PURCHASE_INVOICE, UPDATE_SALE_INVOICE } from '../../../constants/eInvoicePermissions';
import { useActionDeniedSnackbar } from '../../../hooks/useActionDeniedSnackbar';

export default function ResubmitInvoicePage({ isPurchase }) {
  const navigate = useNavigate();
  useDocumentTitle('resubmit invoice');
  const { document_id } = useParams();
  const { loading, hasEInvoicePermission } = usePermissions();
  const showActionDeniedSnackbar = useActionDeniedSnackbar();
  const { invoice, isLoading } = useGetInvoiceHandler(document_id, isPurchase);

  useEffect(() => {
    if (loading) {
      return;
    }
    const updatePermission = isPurchase ? UPDATE_PURCHASE_INVOICE : UPDATE_SALE_INVOICE;
    if (!hasEInvoicePermission(updatePermission)) {
      showActionDeniedSnackbar();
      navigate(isPurchase ? '/purchases/documents?tab=invoices' : '/sales/documents?tab=invoices', { replace: true });
    }
  }, [isPurchase, loading, hasEInvoicePermission, showActionDeniedSnackbar, navigate]);
  const onClickingBackButton = async () => {
    return navigate(isPurchase ? '/purchases/documents?tab=invoices' : '/sales/documents?tab=invoices');
  };

  const onInvoiceResubmitted = () => {
    navigate(isPurchase ? '/purchases/documents?tab=invoices' : '/sales/documents?tab=invoices');
  };

  const { onSubmit, error } = useResubmitInvoiceHandler({ onSuccess: onInvoiceResubmitted, isPurchase });

  const onResubmit = async (data) => {
    const payload = {
      ...data,
      status: 'active',
    };

    await onSubmit(payload, document_id);
  };

  if (isLoading || !invoice) {
    return <DocumentSkeletonForm />;
  }

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <InvoiceForm
        onSubmit={onResubmit}
        onCancel={onClickingBackButton}
        initialData={invoice}
        isPurchase={isPurchase}
        isResubmit={true}
        apiErrors={error ?? {}}
      />
    </Stack>
  );
}
